import React from 'react';
import classnames from 'classnames';
import { FILE_ICONS } from '@gp/constants/icons';
import { Bubble } from 'tea-component';
import type { IBaseProps } from '@home/types/common';
import type { IFile } from '../../types';

import './index.scss';

export interface IFileItemProps extends IBaseProps {
  file?: IFile | null;
  renderActions?: (file?: IFile | null) => React.ReactElement | null;
  onFileNameClick?: (file?: IFile | null) => void;
  onFileNameMouseEnter?: (file?: IFile | null) => void;
  onFileNameMouseLeave?: (file?: IFile | null) => void;
  onMouseEnter?: (file?: IFile | null) => void;
  onMouseLeave?: (file?: IFile | null) => void;
}

const FileItem: React.FC<IFileItemProps> = (props) => {
  const {
    style,
    className,
    file,
    renderActions,
    onFileNameClick,
    onFileNameMouseEnter,
    onFileNameMouseLeave,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const { name = '', format = '' } = file || {};
  const fileIcon = FILE_ICONS[format];

  return (
    <div
      style={style}
      className={classnames('dbg-common-file-item', className)}
      onMouseEnter={() => {
        onMouseEnter?.(file);
      }}
      onMouseLeave={() => {
        onMouseLeave?.(file);
      }}
    >
      {fileIcon && (
        <span
          style={{ backgroundImage: `url("${fileIcon}")` }}
          className="dbg-common-file-item__file-icon"
        ></span>
      )}
      <Bubble
        dark
        content={`${name ? name + (!!format ? `.${format}` : '') : ''}`}
        trigger="hover"
      >
        <div
          className="dbg-common-file-item__file-name-format"
          onClick={(e) => {
            e.stopPropagation();
            onFileNameClick?.(file);
          }}
        >
          <span className="dbg-common-file-item__file-name">{name}</span>
          {!!format && (
            <>
              <span className="dbg-common-file-item__file-format">
                .{format}
              </span>
            </>
          )}
        </div>
      </Bubble>
      {renderActions?.(file)}
    </div>
  );
};

export default FileItem;
